import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

const Technologygcc = () => {
  return (
    <div className="tabing_section healthcare_tabs_sec p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={12} className="text-center">
            <h2 className="head-h2-kinekt">
              Tech Stack <span style={{ color: "#20A2BE" }}>& Tools Used</span>
            </h2>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Frontend">
              <ul>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/frontend/Angular.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Angular</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/frontend/JetPackCompose.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Jetpack Compose</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/frontend/Reactnative.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>React</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/frontend/SwiftUI.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>SwiftUI</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/frontend/Vuejs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Vuejs</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="Backend">
              <ul>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/backend-data/Node-js.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Node js</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/backend-data/Python.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Python</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/backend-data/Ruby-on-Rails.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Ruby on Rails</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Database">
              <ul>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/ecommerce_web/database/MongoDB.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>MongoDB</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/ecommerce_web/database/PostgreSQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={84}
                    height={84}
                  />
                  <div className="text_tabs_web">
                    <h6>PostgreSQL</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Cloud Services">
              <ul>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/cloud-dev/AWS.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>AWS</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/cloud-dev/Azure.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Azure</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/cloud-dev/docker.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Docker</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/cloud-dev/Google_Cloud_Platform.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Google Cloud Platform</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/cloud-dev/kubernets.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>kubernets</h6>
                  </div>
                </li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="AI Integration">
              <ul>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/api-int/GoogleAPI.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>GoogleAPI</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/api-int/GraphQL.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>GraphQL</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/api-int/RESTful_APIs.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>RESTful APIs</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/api-int/Stripe.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Stripe</h6>
                  </div>
                </li>
                <li>
                  <StaticImage
                    src="../../../images/services-usa/logistics-app/api-int/Twilio.webp"
                    alt="tekrevol_web"
                    layout="constrained"
                    placeholder="blurred"
                    formats={["webp"]}
                    width={85}
                    height={85}
                  />
                  <div className="text_tabs_web">
                    <h6>Twilio</h6>
                  </div>
                </li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
